
import forEach from 'lodash/forEach';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';
import get from 'lodash/get';
import map from 'lodash/map';

import stableStringify from 'json-stable-stringify';

import Md5 from 'md5.js';


// const REGEX = 'RE'  // Regex match -- someday
export const CASE_INSENSITIVE_EQUAL = 'I_EQ';  // Insenitive to case, exact match
export const CASE_INSENSITIVE_INCLUDE = 'I_IN';  // Insensitive to case, included in


export function hashFilters(filters) {
  return new Md5().update(stableStringify(filters)).digest('hex');
}


export function getAsPath(datum, path, default_) {
  // We explicitly want to accept fieldnames specified like a "path",
  // e.g., `location.city` access the value at `{ location: { city: XXX }}`
  return get(datum, path, default_);
}


function makeTestFunc(matcher) {

  switch(matcher.type) {

  case CASE_INSENSITIVE_EQUAL:
    return (val)=> get(matcher, 'value', '').toUpperCase() == (val || '').toUpperCase()
  
  case CASE_INSENSITIVE_INCLUDE:
    return (val)=> includes((val || '').toUpperCase(), get(matcher, 'value', '').toUpperCase())

  default:
    throw new Error(`Unexpected matcher type ${matcher.type}`)
  }

}



/**
 * Performs filter operation which is the equivalent of AND-ing each of the filters
 * and OR-ing each of the filter values
 * 
 * @param {Array} filters An array of filter objects like...
 *    [{ fieldName:'geo.city', matchers: [{type:'', value:'Acron'}, ...]}, ...]
 * @param {Array} data An array of plain objects containing the data to filter
 * @returns {Array} A new array of plain objects filtered from the original data
 */
export function applyFilters(filters, data) {
  forEach(filters, ({ fieldName, matchers })=> {

    const testFuncs = map(matchers, makeTestFunc);

    data = filter(
      data, 
      (datum)=> {
        if (isEmpty(testFuncs)) {
          // By definition, we say that a 0-length list of matchers matches everything
          return true;
        }
        // We use a for loop rather than some(map(...)) for improved 
        // efficiency thanks to early exit.
        for (const func of testFuncs) {
          if (func(getAsPath(datum, fieldName))) {
            return true;
          }
        }
        return false;
      }
    )
  });
  return data;
}